export const MODAL_TYPE = {
    BANK_ID: 'BANK_ID',
    SWISH_APP_2_APP: 'SWISH_APP_2_APP',
    SWISH_HANDEL: 'SWISH_HANDEL'
};

export const MODAL_STATUS = {
    START: 'START',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR'
};

export const PAYMENT_OPTIONS = {
    CARD: 'Card',
    PAYNOVA: 'Paynova',
    PAYPAL: 'PayPal',
    APPLEPAY: 'ApplePay',
    GOOGLEPAY: 'GooglePay',
    SWISH_APP_2_APP: 'SwishApp2App',
    SWISH_HANDEL: 'SwishHandel',
    VISA_MASTERCARD: 'VisaMasterCard',
    PAYNOVA_DIRECT_INVOICE: 'PaynovaDirectInvoice',
    PAYNOVA_INSTALLMENTS: 'PaynovaInstallments'
};

export const PAYMENT_OPTION_STATUS = {
    AVAILABLE: 'Available',
    UNAVAILABLE_DUE_TO_AMOUNT: 'UnavailableDueToAmount'
};

export default () => {
    return {
        buyerMember: null,
        checkoutSummary: {
            hasError: false,
            isFetching: false
        },
        hasError: false,
        items: null,
        isFetching: false,
        payment: {
            hasError: false,
            isFetching: false,
            paymentOptions: null,
            selectedPayment: null,
            buyerProtection: false,
            orderCalculation: null,
            paymentMethodData: null
        },
        sellerMember: null,
        modal: {
            open: '',
            status: MODAL_STATUS.START
        },
        showDisableOverlay: false,
        ongoingPaymentAttempt: null,
        shippingInfo: {
            shippingOptions: null,
            shippingPriceRange: null,
            shippingDiscount: null,
            collectionPoints: null,
            selectedCollectionPoint: null,
            isFetching: false
        },
        combinedShippingInfo: null,
        purchaseOrder: null,
        shippingOptionsLoading: false
    };
};
